import { createContext, useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import {
  ControllerDispatcher,
  ControllerState,
} from './hooks/useControllerStates';
import { LogViewerRefType, ProcessedLogsInterface } from './types';
import { SearchStatusInterface } from './LogController/SearchStatus/SearchStatus';

export interface LogViewerContext {
  hideFetch?: boolean;
  hideLines?: boolean;
  hideTimestamp?: boolean;
  controllerState: ControllerState;
  setControllerValue: ControllerDispatcher;
  logViewerRef: LogViewerRefType;
  logs: ProcessedLogsInterface;
  visibleStartIndex: number;
  setVisibleStartIndex: (value: number) => void;
  logsQuery: UseQueryResult;
  searchStatus: SearchStatusInterface;
  resourceName: string;
}

const Context = createContext<LogViewerContext | null>(null);

export function useLogViewerContext() {
  const context = useContext(Context);
  if (context === null) {
    throw new Error(
      'useLogViewerContext must be used within a LogViewerProvider'
    );
  }
  return context;
}

export const LogViewerProvider = Context.Provider;
